import { OnInit, Component, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CasepackService } from '../services/casepack.service';
import { PrintgroupService} from '../services/printgroup.service';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AlertService } from '../services/alert.service';
import { StorageService } from '../services/storage.service';
import jwt_decode from "jwt-decode";
import { Router } from "@angular/router"
import { ProductService } from '../services/product.service';
import { of } from 'rxjs'
import { NgxSpinnerService } from "ngx-spinner";
import { SpinnerService } from './../services/spinner.service';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-casepack',
  templateUrl: './casepack.component.html',
  styleUrls: ['./casepack.component.css']
})
export class CasepackComponent implements OnInit {
  items: any;
  printgroups: any;
  products: any;
  @ViewChild('addCasePack') elCasePack: ElementRef;
  id:number;
  AddShowHide:boolean = true;
  EditShowHide:boolean = true;
  CreateShowHide:boolean = false;
  UpdateShowHide:boolean = false;
  CancelShowHide = false;
  reverse: boolean = false;
  filteredItems:any;
  public filter: string = '';
  public selectedNomenclature = '';
  public username;

  frmCasePack = new FormGroup({
    PrintGroup: new FormControl('', [Validators.required, Validators.minLength(1)]),
    Nomenclature: new FormControl('', [Validators.required, Validators.minLength(1)]),
    SCC : new FormControl(),
    UPC: new FormControl(),
    CasePack: new FormControl('', [Validators.required, Validators.minLength(1)]),
    Weight: new FormControl('', [Validators.required, Validators.minLength(1)]),
    Cube: new FormControl('', [Validators.required, Validators.minLength(1)]),
    Length: new FormControl('', [Validators.required, Validators.minLength(1)]),
    Height : new FormControl('', [Validators.required, Validators.minLength(1)]),
    Width: new FormControl('', [Validators.required, Validators.minLength(1)]),
    Pallets : new FormControl('', [Validators.required, Validators.minLength(1)]),
    Ti : new FormControl('', [Validators.required, Validators.minLength(1)]),
    Hi : new FormControl('', [Validators.required, Validators.minLength(1)]),
    SleeveQuantity : new FormControl(),
    Sleeves : new FormControl(),
    Part  : new FormControl(),
    IsDefault : new FormControl('', [Validators.required, Validators.minLength(1)]),
    CreatedBy: new FormControl(),
    CreationDate: new FormControl()
  });

  config = {
    id: 'CasePack',
    itemsPerPage: environment.pagination.pagesize,
    currentPage: 1,
    totalItems: 0,
    pagerowcount: 0

  };

  param = environment.pagination;
  // {
  //   SortColumnName :"Modifiedby",
  //   SortOrder :"DESC",
  //   PageSelected:0,
  //   PageSize:2
  // };

  constructor(private renderer: Renderer2,
              private _casepackservice: CasepackService,
              private _printgroupservice: PrintgroupService,
              private _alertService: AlertService,
              private _productservice: ProductService,
              private router: Router,
              public storage: StorageService,
              private SpinnerService: NgxSpinnerService,
              private spinner: SpinnerService,private authService: MsalService) {
                // const tokenitems = { ...localStorage };
                // if(tokenitems.TokenInfo != undefined) {
                //     var clienttoken = jwt_decode(JSON.parse(tokenitems.TokenInfo).access_token);
                //     var isAdmin;
                //     var groups;
                //    // //console.log('clienttoken');
                //    // //console.log(clienttoken);
                //     this.username = clienttoken["unique_name"];
                //     groups = clienttoken["groups"].split(',');

                //     isAdmin = groups.indexOf("GPI-Aces-Admins",0) != -1;
                //     if(!isAdmin){
                //         this.router.navigate(['/accessdenied']);
                //     }
                // }


  }
  ngOnInit() {
    this.spinner.showSpinner();
    ////console.log(this.param);
    
 const activeAccount = this.authService.instance.getActiveAccount();
 if (activeAccount) {
   this.username = activeAccount.username;
 }
    this.GetCasePacks();
    this.GetPrintGroups();
    this.GetProducts();
    this.spinner.hideSpinner();
  }
  SortOder(colName, boolean) {
    if (boolean == true) {
        this.items.sort((a, b) => a[colName] < b[colName] ? 1 : a[colName] > b[colName] ? -1 : 0)
        this.reverse = !this.reverse
    }
    else {
        this.items.sort((a, b) => a[colName] > b[colName] ? 1 : a[colName] < b[colName] ? -1 : 0)
        this.reverse = !this.reverse
    }
}
  onPageChange(number: number) {
    this.config.currentPage = number;
    this.config.pagerowcount = this.config.itemsPerPage * (this.config.currentPage == 0 ? this.config.currentPage + 1 : this.config.currentPage);
    this.config.pagerowcount = this.config.pagerowcount > this.config.totalItems ? this.config.totalItems : this.config.pagerowcount;
}

onPageBoundsCorrection(number: number) {
    this.config.currentPage = number;
    this.config.pagerowcount = this.config.itemsPerPage * (this.config.currentPage == 0 ? this.config.currentPage + 1 : this.config.currentPage);
    this.config.pagerowcount = this.config.pagerowcount > this.config.totalItems ? this.config.totalItems : this.config.pagerowcount;
}

  Cancel(){
    this.spinner.showSpinner();
    this.id = 0;
    this.frmCasePack.setValue({Nomenclature:"",
                               PrintGroup:"",
                               SCC:"",
                               UPC:"",
                               CasePack:"",
                               Weight:"",
                               Cube:"",
                               Length:"",
                               Height:"",
                               Width:"",
                               Pallets:"",
                               Ti:"",
                               Hi:"",
                               SleeveQuantity:"",
                               Sleeves:"",
                               Part:"",
                               IsDefault:"",
                               CreatedBy: "",
                               CreationDate: ""
                              });
    this.AddShowHide = true;
    this.EditShowHide = true;
    this.CreateShowHide = false;
    this.UpdateShowHide =false;
    this.CancelShowHide = false;
    this.spinner.hideSpinner();
  }

  changeNomenclature() { 
    //this.filteredItems = this.products.find(
    //  (prd) => prd.nomenclature == this.selectedNomenclature
   // ).PrintGroup;
   this.filteredItems = this.products.filter(item => item.nomenclature === this.selectedNomenclature);
    
    ////console.log(this.selectedNomenclature);
    //console.log(this.filteredItems);
 }

  GetCasePacks() {
    this._casepackservice.getCasePacks().subscribe((data: any) => {
      //console.log('casepacks');
      //console.log(data);
      this.items = data;
      this.config.totalItems = this.items.length;
      setTimeout(() => { this.SpinnerService.hide() }, 500);
  });
  }

  GetPrintGroups(){
    this._printgroupservice.getPrintGroups().subscribe((data: any) => {
      //console.log('printgroups');
      //console.log(data);
      var stringified = JSON.stringify(data);
      this.printgroups = JSON.parse(stringified);

    })
  }
  GetProducts(){
    this._productservice.getProductList().subscribe((data: any) =>{
      //console.log('products');
      //console.log(data);
      this.products = data;
    })
  }

  EditCasePack(item){
    this.spinner.showSpinner();
    //console.log(item);
    this.id = item.id;
    this.frmCasePack.setValue({
      Nomenclature:item.nomenclature,
      PrintGroup:item.printGroup,
      SCC:item.scc,
      UPC:item.upc,
      CasePack:item.casePack1,
      Weight:item.weight,
      Cube:item.cube,
      Length:item.length,
      Height:item.height,
      Width:item.width,
      Pallets:item.pallets,
      Ti:item.ti,
      Hi:item.hi,
      SleeveQuantity:item.sleeveQuantity,
      Sleeves:item.sleeves,
      Part:item.part,
      IsDefault:item.isDefault,
      CreatedBy: item.createdBy,
      CreationDate: item.creationDate
    });

    this.EditShowHide = false;
    this.AddShowHide = false;
    this.CreateShowHide = false;
    this.UpdateShowHide =true;
    this.CancelShowHide = true;

    //console.log(this.EditShowHide);
    //console.log(this.AddShowHide);
    //console.log(this.UpdateShowHide);

    this.spinner.hideSpinner();

  }
  AddCasePack(){
    this.spinner.showSpinner();
    this.id = 0;
    this.AddShowHide = false;
    this.EditShowHide = false;
    this.CreateShowHide = true;
    this.UpdateShowHide =false;
    this.CancelShowHide = true;
    this.spinner.hideSpinner();
  }
  Validation(frmC:FormGroup){
    let invalidfield : String = '';

  if (frmC.invalid) {
      Object.keys(frmC.controls).forEach((key) => {
          if(frmC.get(key).invalid == true){
            //console.log(key);

              // Add validation
              if(key == 'Nomenclature'){
                  invalidfield = "Please enter Nomenclature" +  key.charAt(0).toUpperCase() + key.substr(1).toLowerCase()+ "<br/>";
              } else if(key == 'PrintGroup'){
                  invalidfield += "Please enter Print Group" + key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() + "<br/> ";
              }
              else if(key == 'SCC'){
                invalidfield += "Please enter " + key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() + "<br/> ";
            }
                  else if(key == 'UPC'){
                    invalidfield += "Please enter " + key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() + "<br/> ";
                }
                  else if(key == 'CasePack'){
                    invalidfield += "Please enter " + key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() + "<br/> ";
                }
                  else if(key == 'Weight'){
                    invalidfield += "Please enter " + key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() + "<br/> ";
                }
                  else if(key == 'Cube'){
                    invalidfield += "Please enter " + key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() + "<br/> ";
                }
                  else if(key == 'Length'){
                    invalidfield += "Please enter " + key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() + "<br/> ";
                }
                  else if(key == 'Height'){
                    invalidfield += "Please enter " + key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() + "<br/> ";
                }
                  else if(key == 'Width'){
                    invalidfield += "Please enter " + key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() + "<br/> ";
                  }
                  else if(key == 'Pallets'){
                    invalidfield += "Please enter " + key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() + "<br/> ";
                  }
                  else if(key == 'Ti'){
                    invalidfield += "Please enter " + key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() + "<br/> ";
                  }
                  else if(key == 'Hi'){
                    invalidfield += "Please enter " + key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() + "<br/> ";
                  }
                  else if(key == 'SleeveQuantity'){
                    invalidfield += "Please enter " + key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() + "<br/> ";
                  }
                  else if(key == 'Hi'){
                    invalidfield += "Please enter " + key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() + "<br/> ";
                  }
                  else if(key == 'Sleeves'){
                    invalidfield += "Please enter " + key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() + "<br/> ";
                  }
                  else if(key == 'Part'){
                    invalidfield += "Please enter " + key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() + "<br/> ";
                  }
                  else if(key == 'IsDefault'){
                    invalidfield += "Please enter " + key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() + "<br/> ";
                  }
          }

      });
      this._alertService.showError(invalidfield);
      this.Cancel();
    }
  }
  CreateCasePack() {
    this.spinner.showSpinner();
    if (this.frmCasePack.invalid) {
      this.Validation(this.frmCasePack);
      this.spinner.hideSpinner();
    }

    let CasePackModel = {
      nomenclature: this.frmCasePack.get('Nomenclature').value,
      printGroup: this.frmCasePack.get('PrintGroup').value,
      scc: this.frmCasePack.get('SCC').value,
      upc: this.frmCasePack.get('UPC').value,
      casePack1: this.frmCasePack.get('CasePack').value,
      weight: this.frmCasePack.get('Weight').value,
      cube: this.frmCasePack.get('Cube').value,
      length: this.frmCasePack.get('Length').value,
      height: this.frmCasePack.get('Height').value,
      width: this.frmCasePack.get('Width').value,
      pallets: this.frmCasePack.get('Pallets').value,
      ti: this.frmCasePack.get('Ti').value,
      hi: this.frmCasePack.get('Hi').value,
      sleeveQuantity: this.frmCasePack.get('SleeveQuantity').value,
      sleeves: this.frmCasePack.get('Sleeves').value,
      part: this.frmCasePack.get('Part').value,
      isDefault: this.frmCasePack.get('IsDefault').value,
      createdBy: this.username,
      creationDate: new Date(),
      lastModifiedBy: this.username,
      lastModificationDate: new Date()
    }

    let retvalue = this._casepackservice.postCasePack(CasePackModel);
    retvalue.pipe(
      catchError(err => {
        this._alertService.showError("Error while creating record");
        return of(null);
      })).subscribe((value: any) => {
        this.param.SortOrder = "DESC";
      this.GetCasePacks();
      this.Cancel();
      this._alertService.showSuccess("Record created successfully");
      })

      this.spinner.hideSpinner();
    }

    UpdateCasePack() {
      this.spinner.showSpinner();
      if (this.frmCasePack.invalid) {
        this.Validation(this.frmCasePack);
        this.spinner.hideSpinner();

      }
     
      //console.log(this.frmCasePack);
      let CasePackModel = {
        id: this.id,
        nomenclature: this.frmCasePack.get('Nomenclature').value,
        printGroup: this.frmCasePack.get('PrintGroup').value,
        scc: this.frmCasePack.get('SCC').value,
        upc: this.frmCasePack.get('UPC').value,
        casePack1: this.frmCasePack.get('CasePack').value,
        weight: this.frmCasePack.get('Weight').value,
        cube: this.frmCasePack.get('Cube').value,
        length: this.frmCasePack.get('Length').value,
        height: this.frmCasePack.get('Height').value,
        width: this.frmCasePack.get('Width').value,
        pallets: this.frmCasePack.get('Pallets').value,
        ti: this.frmCasePack.get('Ti').value,
        hi: this.frmCasePack.get('Hi').value,
        sleeveQuantity: this.frmCasePack.get('SleeveQuantity').value,
        sleeves: this.frmCasePack.get('Sleeves').value,
        part: this.frmCasePack.get('Part').value,
        isDefault: this.frmCasePack.get('IsDefault').value,
        createdBy: this.frmCasePack.get('CreatedBy').value,
        creationDate: this.frmCasePack.get('CreationDate').value,

        LastModifiedBy: this.username,
        LastModificationDate: new Date()
      }

      let retvalue = this._casepackservice.putCasePack(CasePackModel);

      retvalue.pipe(
        catchError(err => {
          alert("Error while creating record!!!");
          return of(null);
        })).subscribe((value: any) => {
          this.param.SortOrder = "DESC";
          this.GetCasePacks();
          this.Cancel();
          setTimeout("",1000);
          this._alertService.showSuccess("Record updated successfully");
        })

        this.spinner.hideSpinner();
    }

    DeleteCasePack(casepackid: number){
      if (confirm('Are you sure, you want to delete the product?')) {
        this._casepackservice.deleteCasePack(casepackid).subscribe(
          (data: any) => {
            this._alertService.showSuccess("Deleted successfully");
          },
          err => {
             if (err.status == 400)
               this._alertService.showError("No data exists");
             else
               this._alertService.showError("Bad request");
          }
    );
    this.GetCasePacks(); 
      }           
    }
  }
